<template>
  <div style="height: 100%">
    <yq-table :data="rightList" height="100%" border>
      <yq-table-column label="权限" prop="permName" :align="'center'">
        <template v-slot="{row}"><span :class="row.disabled? 'row-label-disabled': ''">{{ row.permName }}</span>
        </template>
      </yq-table-column>
      <yq-table-column label="授权标识" prop="permFlag" align="center">
        <template v-slot="{row}">{{ row.permFlag }}</template>
      </yq-table-column>
      <yq-table-column label="授权" :align="'center'">
        <template #header>
          <el-checkbox @click.stop="true" v-model="selfSelectAll" @change="changeSelfAll"
                       :indeterminate="indeterminate"/>
        </template>
        <template v-slot="{row, $index}">
          <el-checkbox @click.stop="true" :disabled="row.disabled" v-model="row.self"
                       @change="changeValue(row.permFlag)"/>
        </template>
      </yq-table-column>
    </yq-table>
  </div>
</template>

<script>
import {watch} from "vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";

export default {
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    // 系统的全部权限功能
    rightList: {
      default: () => []
    },
    // 菜单功能支持的权限
    moduleAccessRight: {
      default: "",
    }
  },
  name: "AMC",
  components: {
    YqTableColumn,
  },
  data() {
    return {
      checkedList: [],
      // 访问权限{label, value, disabled, grant}
      accessRightList: [],
      selfSelectAll: false, // 权限，全部选中
      indeterminate: false, // 是否半选中
    };
  },
  created() {
    watch(() => this.modelValue, () => {
      this.initData();
    });
    // eslint-disable-next-line no-empty-pattern
    watch(() => [this.rightList, this.moduleAccessRight], ([]) => {
      this.initData();
    })
  },
  unmounted() {
  },
  methods: {
    // 全选，全不选
    changeSelfAll() {
      if (this.selfSelectAll) {
        // 全部选中
        for (let i = 0; i < this.rightList.length; i++) {
          // eslint-disable-next-line vue/no-mutating-props
          this.rightList[i].self = true;
        }
        this.selfSelectAll = true;
        this.indeterminate = false;
        this.changeValue()
      } else {
        // 全部取消
        for (let i = 0; i < this.rightList.length; i++) {
          // eslint-disable-next-line vue/no-mutating-props
          this.rightList[i].self = false;
        }
        this.selfSelectAll = false;
        this.indeterminate = false;
        this.changeValue()
      }

    },
    changeValue() {
      let perms = ""
      let count = 0;
      for (let i = 0; i < this.rightList.length; i++) {
        if(this.rightList[i].self){
          perms += this.rightList[i].permFlag + ",";
          count++
        }
      }
      this.$emit("update:modelValue", perms ? perms.substring(0, perms.length - 1) : "");
      // 检查是否需要半选中或全选
      if (count > 0 && count < this.rightList.length) {
        this.indeterminate = true;
      } else if (count === this.rightList.length) {
        this.indeterminate = false;
        this.selfSelectAll = true;
      } else {
        this.indeterminate = false;
        this.selfSelectAll = false;
      }
    },
    initData() {
      let perms = this.modelValue;
      let arr = perms.split(",")
      for (let i = 0; i < this.rightList.length; i++) {
        for (let j = 0; j < arr.length; j++) {
          if(this.rightList[i].permFlag === arr[j]){
            // eslint-disable-next-line vue/no-mutating-props
            this.rightList[i].self = true;
          }
        }
      }
      if(arr.length === this.rightList.length){
        this.selfSelectAll = true;
        this.indeterminate = false;
        return
      }
      if(arr.length > 0){
        this.indeterminate = true;
        this.selfSelectAll = false;
        return;
      }
      this.indeterminate = false;
      this.selfSelectAll = false;
    },
  }
};
</script>

<style lang="scss" scoped>
.row-label-disabled {
  color: #999;
}

:deep(.el-table__row.row-disabled) {
  background-color: #fafafa;
}
</style>